import {
  IconMapCar16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
  IconMapWalk16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ETransportType, EUndergroundType } from '../../../types/promoInventory';

export const transportIconMap: Record<ETransportType, React.FC> = {
  [ETransportType.Walk]: IconMapWalk16,
  [ETransportType.Transport]: IconMapCar16,
};

export const metroIconMap: Record<EUndergroundType, React.FunctionComponent> = {
  [EUndergroundType.Spb]: IconMapMetroSpb16,
  [EUndergroundType.Mow]: IconMapMetroMsk16,
  [EUndergroundType.Ekb]: IconMapMetroEkb16,
  [EUndergroundType.Kzn]: IconMapMetroKzn16,
  [EUndergroundType.Nsk]: IconMapMetroNovosib16,
  [EUndergroundType.Nn]: IconMapMetroNN16,
  [EUndergroundType.Smr]: IconMapMetroSam16,
};
